var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffidavits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0_7695_60)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7695_60",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7695_60",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7695_60",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE9ElEQVR4nO2dTYhcRRDHO6Io+B3N7uua1cUQvwKCICgIfqEIehVPfhz1FIOZ6ZqZ0woiiILgLV6FiMTPq148KGJQUeJmqmbMGmQ1CaiHXTQaNzpSb3dMXHbGNzO70x+v/lAwsPN6quu31fVed7/3jFGpVCqVSqVSRaKZZ+e3Z651T8Xxo+FY++Gp5uFpUyZBo3UDOH4HHK8Acjc0s45PW8d1UwbZWutBQF72HXQoBuZlk3xmRAIDygAFkN71HWBQKGcLeKg1A4pkCtIrJiVVHN3nO6igUM4qq9EjvgMKg8zxh9bRodLUFDnHD3tI4oM76wuXW6TPSjF8xQDEGGNKAyUWIKWBEhOQUkCJDUjyUGIEkjSUWIEkCyVmIElCiR1IclBSAJIUlFSAJAMlJSBJQEkNSPRQUgQSNZRUgUQLJWUg/0Iptp4Sxm6W0IEA0ifj9rEIFIv0x3T16JTxrdCBWKRTWfXI7CSgZMgPGd8KHQjkwwkdmgQUiYXxrRiAwCqU32X4kpoyjgHyBwoE4zDNEPQPQYGg/8ArEPQfbAWC/gOsQNB/UBVIAIEEBeI/eKBA/AcMFIj/IIEC8R8YUCD+gwEBmE6doH8ICgT9B16BoP9gKxD0H2AFgv6DqkACCCQoEP/BAwWSvlnkTwutyzs+YJFfglr7ATPXPa+UmxwgULNIX0GtfasCwaDsV0C6UzMEA8oUx8evcnSpDlkY0vDVaioQDMo+VyAYlC1HC8SOeZuBT61tSd2wX2M3rkCGV5JAwNFChu2bTWQSn8X39IBg/rS43zKkp00kEl/F50F9SuNK3dH7dh9fbQKV+CY+FulLGkAwz5aT8jhxE5jA8f0W6Yei/UgHCIrR3+D41V17Ohcaz7rtqS8usI6eA0d/DdOHxIBwz76ZqdMtxpNsk28C5C9H8T1VIF252dM62mtMd9umRLloPGrtJ1cnC0fzO1kgMOGCP7v32BUW6c1x/Y0YCH0HSEvFsoV/zBeDtkjSdv4bxfxeSvI6xCIflFudwdHHvgr+sIVbbqmeaczvSvJK3fbmsuY+Ol8ea2GR/5xkwR+ucNMZQHpRAObHJg1kTZVq+w6LdHQSBX+owu34e+vad517fCmA9J60AMhvFG+H3suanR2moOS7ckzh9h0fEJ/Wt1MaID1ljp8YouD/YpGeGbR8Kn+TjJLvFgS9lNX58X7tlQ6IaKrR3inbcoZoc1leaGaRUYYkMfm89vagwq9zkt+crvJ1ZoBKCWTEgj+G/bdwD1J5gYxQ8EeyDQr3IJUeiGj7ns5lgPT6VvxjXNs4fKUZQgpkXUZbR4tjg3C0OOotbApknXbMzV8CyC9Yxz+PUCt+ssjPT1e/vtiMKAXSR7Nzxy6S01NAfhuQT/TPBj5uHb9lHT22GVMvCqSgYN+318xg+3Z5dqKYfK5gZ8ZsshRIYFIgZQLi68WSVncubqxKne5VIAFlyOrS5SSmJlgzpKjWThsVSAgZIqq4I9cXne7WDDFbD6S30D9JKFaL+v8rX8CXK9oJ1BSrQIpLZj+zevtumXwb16zj0xsCcbQ47nPcvVmfyU3pqwldkO+/muwJgy+TNRsTugD5tdIAcbzfhC5wdCM4XvEdrK03OpNVO7tNDLLYaiafHXVumHjU3ZZDSTFTHK8E80KxYZVVO7vzmuJood/ZVwyW+77ah/2yJfXcTv4DQgiZKE7I4aUAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffidavits);
export default __webpack_public_path__ + "static/media/affidavits.6dfa227af84af6a6a3fdac97624fd4ef.svg";
export { ForwardRef as ReactComponent };